// Listeners refresh contact list, notifications, session, config
export const WEB_APP_DATA_CHANGED_EVENT = 'web-app-data-changed';

export function dispatchWebAppDataChanged(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(WEB_APP_DATA_CHANGED_EVENT));
  }
}
